import * as React from "react";
import './Faq.scss';
import { IFaq, IFaqQuestion } from "../../models/IFaq";
import { FaqQuestions } from "./FaqQuestions";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from "../../App";
import { FaqApi } from "../../api/FaqApi";
import { SpinnerWrapper } from "soprasteria-ui-library";
import { FaqModal } from "./FaqModal";

export const Faq: React.FunctionComponent<{}> = () => {
    const auth = useAuth();
    const faqApi = new FaqApi(auth);
    const [faq, setFaq] = React.useState<IFaq[]>();
    const abortController = new AbortController();
    const [modalData, setModalData] = React.useState<IFaqQuestion>();

    React.useEffect(() => {
        faqApi.getFaq((faq: IFaq[]) => {
            setFaq(faq);
        });
        return () => {
            abortController.abort();
        }
    }, [])

    const populateModal = (faqId: number) => {
        faqApi.getFaqQuestion(faqId, (data: IFaqQuestion) => {
            setModalData(data);
            document.getElementById("open-modal")?.click();
        });
    }

    return (
        <>
            <SpinnerWrapper isLoading={faq === undefined}>
                <section className="faq__wrapper">
                    <div className="card">
                        <div className="card-header">
                            <h2>FAQ</h2>
                        </div>
                        <div className="card-body" id="faq-accordion">
                            {
                                faq?.map((f, key) =>
                                    <div key={key} className="category-wrapper">
                                        <button className="btn btn-link text-left" data-toggle="collapse" data-target={`#faq-collapse${key}`} aria-controls={`faq-collapse${key}`}>
                                            <h4 className="row">
                                                <div className="col-1">
                                                    <FontAwesomeIcon size="sm" icon={faPlus} />
                                                </div>
                                                <span className="col"> {f.faqCategory.category}</span>
                                            </h4>
                                        </button>
                                        <div id={`faq-collapse${key}`} className="collapse" aria-labelledby={`faq-heading${key}`} data-parent="#faq-accordion">
                                            <FaqQuestions
                                                questions={f.faqQuestion}
                                                populateModal={val => populateModal(val)} />
                                        </div>
                                    </div>)
                            }
                        </div>
                    </div>
                </section >
            </SpinnerWrapper>
            <input type="hidden" data-toggle="modal" id="open-modal" data-target="#faq-modal" />
            <FaqModal modalData={modalData} />
        </>
    )
}



